import { IApiPage, UserMetadata } from '@skedulo/horizon-core'

export const generateMockPageData = (): IApiPage => ({
  uid: 'test-page-uid',
  name: 'Test page',
  userId: '',
  tenantId: '',
  templateId: 'test-template-id',
  slug: 'test-page-slug',
  description: 'Test page description',
  published: true,
  pageType: 7,
  isSystemGenerated: true,
  createdAt: new Date('2022-10-27T10:01:04.998Z'),
  createdBy: 'test-user-id',
  updatedAt: new Date('2023-10-17T08:51:04.277Z'),
  updatedBy: 'test-user-id',
  deletedAt: undefined,
  deletedBy: '',
})

export const generateMockUserData = () => ({
  Email: 'test.user@skedulo.com',
  IsActive: true,
  LastLoginDate: '2023-11-06T19:13:47.866Z',
  Name: 'Test User',
  UserTypes: ['Administrator', 'Scheduler', 'Resource'],
  FirstName: 'Test',
  UID: 'test-user-uid',
  LastName: 'User',
})

export const generateMockUserMetadata = (): UserMetadata => ({
  id: 'test-user-uid',
  email: 'test.user@skedulo.com',
  username: 'test.user@skedulo.com',
  fullName: 'Test User',
  orgName: 'Test Org',
  isSkeduloScheduler: true,
  isSkeduloUser: true,
  isSkeduloAdmin: false,
  smallPhotoUrl: null,
  category: null,
  resourceId: 'test-resource-id',
  latitude: null,
  longitude: null,
  address: null,
  timezone: 'Australia/Brisbane',
  country: null,
})
